import React, { useEffect, useState } from "react";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function SolicitudesDistribuidor() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [sel, setSel] = useState(null);
  const [q, setQ] = useState("");
  const [approving, setApproving] = useState(false);

  // cancelación
  const [cancelingId, setCancelingId] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const [cancelBusy, setCancelBusy] = useState(false);

  const load = async () => {
    try {
      setLoading(true); setErr("");
      const r = await fetch(`${API_BASE}/api/admin/ascensos`, { credentials: "include" });
      const j = await r.json();
      if (!j.ok) throw new Error(j.msg || "Error");
      setRows(j.data || []);
    } catch (e) {
      setErr(String(e.message || e));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const filtered = rows.filter((x) => {
    const s = (v) => String(v || "").toLowerCase();
    const term = q.toLowerCase();
    return s(x.nombreCompleto).includes(term) || s(x.email).includes(term) || s(x.empresa).includes(term);
  });

  const aprobar = async (id) => {
    const ok = typeof window !== "undefined" ? window.confirm("¿Aprobar ascenso a Distribuidor?") : true;
    if (!ok) return;
    try {
      setApproving(true);
      const r = await fetch(`${API_BASE}/api/admin/ascensos/${id}/aprobar`, {
        method: "POST", credentials: "include"
      });
      const j = await r.json();
      if (!j.ok) throw new Error(j.msg || "No se pudo aprobar");
      setRows((prev) => prev.filter((x) => x.id !== id));
      if (sel?.id === id) setSel(null);
      alert("✅ Usuario ascendido a Distribuidor");
    } catch (e) {
      alert("❌ " + (e.message || e));
    } finally {
      setApproving(false);
    }
  };

  const cancelar = async (id) => {
    if (!cancelReason.trim()) return alert("Debes indicar un motivo.");
    const ok = window.confirm("¿Cancelar esta solicitud? Se notificará por correo al usuario.");
    if (!ok) return;
    try {
      setCancelBusy(true);
      const r = await fetch(`${API_BASE}/api/admin/ascensos/${id}/cancelar`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ motivo: cancelReason.trim() }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || !j.ok) throw new Error(j?.msg || "No se pudo cancelar");
      setRows((prev) => prev.filter((x) => x.id !== id));
      if (sel?.id === id) setSel(null);
      setCancelingId(null);
      setCancelReason("");
      alert("✅ Solicitud cancelada. Correo enviado.");
    } catch (e) {
      alert("❌ " + (e.message || e));
    } finally {
      setCancelBusy(false);
    }
  };

  const abs = (p) => (p ? (p.startsWith("http") ? p : `${API_BASE}${p}`) : "#");

  return (
    <div className="p-6">
      <style>{`
        .card{background:#fff;border:1px solid #e5e7eb;border-radius:14px;padding:16px}
        .btn{padding:8px 14px;border-radius:10px;font-weight:600}
        .btn-light{background:#fff;border:1px solid #e5e7eb}
        .btn-brand{background:#244A9B;color:#fff}
        .btn-danger{background:#dc2626;color:#fff}
      `}</style>

      <h1 className="text-2xl font-bold">Solicitudes de Usuario a Distribuidor</h1>
      <p className="text-slate-600 mb-4">Revisa los documentos y aprueba el ascenso.</p>

      <div className="flex items-center gap-3 mb-4">
        <input
          className="border rounded-lg px-3 py-2 w-full max-w-sm"
          placeholder="Buscar por nombre, email, empresa…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <button className="btn btn-light" onClick={load}>Recargar</button>
      </div>

      {loading ? (
        <div>Cargando…</div>
      ) : err ? (
        <div className="text-red-600">{err}</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {/* listado */}
          <div className="card">
            <div className="text-sm text-slate-500 mb-2">{filtered.length} pendientes</div>
            <div className="divide-y">
              {filtered.map((s) => (
                <div key={s.id} className="py-3">
                  <div className="flex items-start gap-3">
                    <div className="flex-1">
                      <div className="font-semibold">{s.nombreCompleto}</div>
                      <div className="text-sm text-slate-600">{s.email}</div>
                      <div className="text-xs text-slate-500">{s.empresa || "—"}</div>
                      <div className="text-xs text-slate-500">Tipo actual: {s.tipoUsuario}</div>
                    </div>

                    <div className="flex flex-col gap-2 w-full max-w-[220px]">
                      <button className="btn btn-light" onClick={() => setSel(s)}>Revisar</button>
                      <button className="btn btn-brand" onClick={() => aprobar(s.id)} disabled={approving}>
                        {approving ? "Aprobando…" : "Aprobar"}
                      </button>

                      {cancelingId === s.id ? (
                        <>
                          <input
                            className="border rounded-lg px-2 py-1 text-sm"
                            placeholder="Motivo de cancelación"
                            value={cancelReason}
                            onChange={(e) => setCancelReason(e.target.value)}
                          />
                          <div className="flex gap-2">
                            <button className="btn btn-danger" disabled={cancelBusy} onClick={() => cancelar(s.id)}>
                              {cancelBusy ? 'Cancelando…' : 'Confirmar'}
                            </button>
                            <button className="btn btn-light" onClick={() => { setCancelReason(''); setCancelingId(null); }}>
                              Atrás
                            </button>
                          </div>
                        </>
                      ) : (
                        <button className="btn btn-light" onClick={() => { setCancelingId(s.id); setCancelReason(''); }}>
                          Cancelar solicitud
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
              {!filtered.length && <div className="py-8 text-center text-slate-500">No hay solicitudes</div>}
            </div>
          </div>

          {/* detalle */}
          <div className="card">
            <h2 className="font-bold mb-3">Detalle</h2>
            {!sel ? (
              <div className="text-slate-500">Selecciona una solicitud para ver sus documentos.</div>
            ) : (
              <div className="space-y-3">
                <div className="text-lg font-semibold">{sel.nombreCompleto}</div>
                <div className="text-sm text-slate-600">{sel.email} · {sel.empresa || "—"}</div>

                <div className="grid sm:grid-cols-3 gap-3 text-sm mt-2">
                  <a className="btn btn-light text-center" href={abs(sel.dpi)} target="_blank" rel="noopener noreferrer">Ver DPI</a>
                  <a className="btn btn-light text-center" href={abs(sel.rtu)} target="_blank" rel="noopener noreferrer">Ver RTU</a>
                  <a className="btn btn-light text-center" href={abs(sel.patente)} target="_blank" rel="noopener noreferrer">Ver Patente</a>
                </div>

                <div className="flex flex-wrap gap-2 pt-2">
                  <button className="btn btn-light" onClick={() => setSel(null)}>Cerrar</button>
                  <button className="btn btn-brand" onClick={() => aprobar(sel.id)} disabled={approving}>
                    {approving ? "Aprobando…" : "Aprobar ascenso"}
                  </button>

                  {cancelingId === sel.id ? (
                    <>
                      <input
                        className="border rounded-lg px-2 py-1 text-sm"
                        placeholder="Motivo de cancelación"
                        value={cancelReason}
                        onChange={(e) => setCancelReason(e.target.value)}
                      />
                      <button className="btn btn-danger" disabled={cancelBusy} onClick={() => cancelar(sel.id)}>
                        {cancelBusy ? 'Cancelando…' : 'Confirmar cancelación'}
                      </button>
                      <button className="btn btn-light" onClick={() => { setCancelingId(null); setCancelReason(''); }}>
                        Atrás
                      </button>
                    </>
                  ) : (
                    <button className="btn btn-light" onClick={() => { setCancelingId(sel.id); setCancelReason(''); }}>
                      Cancelar solicitud
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
